import { useTranslation } from 'next-i18next';
import React from 'react';
import { ImageContainer } from '@/components/atoms/ImageContainer/ImageContainer';
import { IconUspCancel } from '@/components/Icons/IconUspCancel';
import { IconUspDelivery } from '@/components/Icons/IconUspDelivery';
import { IconUspRepairs } from '@/components/Icons/IconUspRepairs';
import { CloudinaryImage } from '@/components/local/CloudinaryImage/CloudinaryImage';
import nameSpacesConfig from '@/config/config.nameSpaces.json';
import { ProductConfig } from '@/data/productsConfig';
import styles from './BikeImage.module.scss';

interface Props {
  imageSrc: string;
  label: React.ReactNode;
  productConfig: ProductConfig;
}

export const BikeImage = ({ imageSrc, label, productConfig }: Props) => {
  const { t } = useTranslation(nameSpacesConfig.pages);
  return (
    <>
      <ImageContainer ratioWidth={4} ratioHeight={3}>
        <CloudinaryImage
          className={styles.image}
          src={imageSrc}
          alt={t('configure.image.alt')}
          layout="fill"
          objectFit="contain"
          priority
          sizes={
            '(max-width: 768px) 100vw,' + '(max-width: 1360px) 50vw,' + '600px'
          }
        />
        {label}
      </ImageContainer>
      <div className={styles.checkList}>
        <div>
          <IconUspDelivery className={styles.uspIcon} />
          <span>
            <strong>{t('configure.image.usps.label1')}</strong>
          </span>
        </div>
        <div>
          <IconUspRepairs className={styles.uspIcon} />
          <span>
            <strong>{t('configure.image.usps.label2')}</strong>
          </span>
        </div>
        <div>
          <IconUspCancel className={styles.uspIcon} />
          <span>
            <strong>{t('configure.image.usps.label3')}</strong>
          </span>
        </div>
      </div>
      {/*
        Power+ is always in one color which is 'black',
        so no need to show this disclaimer about the bike color.
      */}
      {productConfig.id !== 'power-plus' && (
        // TODO: check if the next issue is resolved,
        // so the Typography/P can be used instead with the overwritten styles.
        // https://github.com/vercel/next.js/issues/64921
        <p className={styles.disclaimer}>
          {t('configure.image.disclaimerTextNew')}
        </p>
      )}
    </>
  );
};
